import { construct, destruct } from '@aximario/json-tree';
export let props = ['width','placeholder','value',
  'userOrg' // 该属性为一个开关，用于切换是否为用户组织机构模式，若为true，则本组件获取和选中的是根据当前用户权限
  // 所拥有的组织机构（公司）及其麾下的站点
];
export let model = {
  modelValue: {},
  organizationList:[],
  organizationListFlat:[],
};
export let computed = {
  // // 列表
  // _options(){
  //  return this.organizationList
  // },
  // v-model
  _value: {
    get() {
      return this.modelValue;
    },
    set(v) {
      this.modelValue = v;
      this.$emit('input', this.modelValue ? (this.modelValue.organizationId ? this.modelValue.organizationId : undefined) : undefined);
    }
  }
};
